<template>
    <div>
        <config-main-title>
            Campos Obrigatórios do Paciente
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir
                </button>
            </div>
        </div>
        
        <p class="alert alert-info">
            Campos obrigatórios do cadastro do paciente para o atendimento.
        </p>

        <template v-if="!exibicao.length">
            <az-empty-state />
        </template>

        <template v-else>
            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in exibicao" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary">
                                {{ dado.in_regra_ordem }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>
        </template>

        <!-- Modal Cadastro -->
        <div class="modal fade" id="cadCamposObrigModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Campos Obrigatórios
                            <span class="badge badge-secondary ml-2">
                                {{ ( item && item.id_paciente_campo_obrigatorio ) ? '#' + item.id_paciente_campo_obrigatorio : 'Novo' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Idade Mínima CPF"
                                    type="number"
                                    placeholder="0..."
                                    :validate="validate"
                                    :edicao="( item.js_campos && item.js_campos.find(campo => campo == 'cadastro.st_cpf') ) ? true : false"
                                    v-model="item.in_idade_minima_cpf" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Ordem"
                                    type="number"
                                    :validate="validate"
                                    required
                                    v-model="item.in_regra_ordem" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <template v-if="item.campos">

                            <az-sub-title class="mt-3" title="Campos Obrigatórios"></az-sub-title>

                            <div class="row" v-for="(campo, icx) in item.js_campos" :key="icx">
                                <div class="col col-12">
                                    <az-input
                                        type="label"
                                        :label="titulo_campo(campo)">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" @click="remover_campo(item, icx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div class="row" v-if="item.campos">
                                <div class="col col-12">
                                    <az-input
                                        icon="fa fa-plus"
                                        type="select"
                                        placeholder="Selecione o campo desejado..."
                                        :optionsList="item.campos"
                                        optionsData="campo"
                                        optionsDisplay="titulo"
                                        v-model="novoCampo"
                                        @input="selecionar_campo" />
                                </div>
                            </div>

                        </template>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br><br><br><br>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="pacienteCampoObrigatorio" :id="item.id_paciente_campo_obrigatorio" v-if="item && item.id_paciente_campo_obrigatorio" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            dados: null, 
            novoCampo: "", 
            lista: [], 
            viewMode: "A", 
            search: "", 
            item: null, 
            validate: false, 
        }
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];

            opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'});
            
            return opcoes;
        },

        exibicao: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return ( this.lista && this.lista.length ) ? 
                this.lista.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : [];
        },
    },

    components: { 
        AzEmptyState,
        AzInput,
        ConfigMainTitle,
        AzSubmit, 
        AzSubTitle, 
        FiltroModel,
        AzAuditLogButton
    },

    methods: { 
        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'paciente_campo_obrigatorios',
                dados: this.item, 
                toast: true, 
                reload: true, 
                modal: 'cadCamposObrigModal',
            });
        },

        remover_campo(dados, icx) { 
            dados.js_campos.splice(icx, 1);
        },

        titulo_campo(campo) { 
            if ( !this.item ) 
                return campo;

            let item = this.item.campos.find(cp => cp.campo == campo);
            return item ? item.titulo : campo;
        },

        selecionar_campo() { 
            if ( this.novoCampo ) { 
                if ( this.item.js_campos.find(campo => campo == this.novoCampo ) ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Campo já selecionado.",
                        life: 3000
                    });
                } else { 
                    this.item.js_campos.push(this.novoCampo);
                }
            } else { 
                return;
            }

            this.novoCampo = null;

            this.$nextTick(() => { 
                this.novoCampo =  "";
            });
        },

        editar (item) { 
            this.validate = false; 
            this.item = _.cloneDeep(item);
            $('#cadCamposObrigModal').modal('show');
        },

        incluir () { 
            this.validate = false; 

            this.item = {
                st_titulo: "",
                st_observacoes: "",
                in_regra_ordem: 100,
                js_campos: [],
                fl_ativo: true, 
                filtros: [], 
            };

            $('#cadCamposObrigModal').modal('show');
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'paciente_campo_obrigatorios',
                dados: item,
            });

        },

        load() { 
            this.$util.load(this, { 
                service: 'paciente_campo_obrigatorios',
                parms: { 
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.lista = res;
                    // this.dados = res[0];
                }
            });
        }
    },

    mounted() { 
        this.load();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Campos Obrigatórios do Paciente" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    }
}
</script>